import { ReactNode } from "react";

import { useAppSelector } from "app/hooks";
import CircularProgress from "components/circular-progress";
import { PRE_AUTH_USER_ID, selectCurrentUser } from "features/auth/auth-slice";
import useCanUseVoiceScreens from "hooks/use-can-use-voice-screens.hook";

import VoiceSeatNotice from "./voice-seat-notice.component";

type VoiceScreensRouteProps = { children: ReactNode };

// The gate on every Voice screen route: /calls/* and both placements of a
// patient's Calls tab (ENG-2315). Someone without access gets the notice as a
// page, never a silent redirect. Until /me/ replaces the pre-auth placeholder
// there is nothing to decide on, so it holds a spinner rather than flash the
// notice or let the screen fire requests the API would refuse.
export default function VoiceScreensRoute({
  children
}: VoiceScreensRouteProps) {
  const currentUser = useAppSelector(selectCurrentUser);
  const canUseVoiceScreens = useCanUseVoiceScreens();

  if (!currentUser || currentUser.id === PRE_AUTH_USER_ID) {
    return <CircularProgress />;
  }
  if (!canUseVoiceScreens) return <VoiceSeatNotice variant="page" />;
  return <>{children}</>;
}
